(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name commons.controller:ConfirmDialogCtrl
     *
     * @description
     *
     */
    angular
        .module('commons')
        .controller('InfoDialogCtrl', InfoDialogCtrl);

    function InfoDialogCtrl($uibModalInstance, modalParams) {
        var vm = this;

        vm.model = {
            title: modalParams.title,
            msgCol: modalParams.messages || [],
        };

        vm.onCloseClick = function () {
            $uibModalInstance.close(modalParams.close);
        };

      vm.onYesClick = function(){
        $uibModalInstance.close('YES');
      };

      vm.onNoClick = function(){
        $uibModalInstance.close();
      };
    }
}());
